import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { defaultEditorLength, Editor } from "@/components/ui/editor"
import { TreatmentForm } from "@/modules/admin/treatment/schema/treatment-form-schema"
import { Language, LanguageValues } from "@/types/__generated__/union-types"

type InstructionFieldName = "germanInstruction" | "frenchInstruction" | "italianInstruction" | "englishInstruction"

const INSTRUCTION_FIELD_BY_LANGUAGE: Record<Language, InstructionFieldName> = {
  GERMAN: "germanInstruction",
  FRENCH: "frenchInstruction",
  ITALIAN: "italianInstruction",
  ENGLISH: "englishInstruction",
}

const instructionFields = LanguageValues.map((language) => ({
  language,
  fieldName: INSTRUCTION_FIELD_BY_LANGUAGE[language],
}))

const TreatmentPlanTemplatesSectionInstructionForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<TreatmentForm>()

  const { control } = form

  return (
    <div className="w-full">
      <div className="text-on-surface-subdued col-span-4 text-sm font-medium">
        <label>{t("admin.treatment.form.followUp")}</label>
      </div>
      <div className="mt-2 grid grid-cols-2 gap-4">
        {instructionFields.map(({ language, fieldName }, index) => (
          <div key={language} className={index < instructionFields.length - 2 ? "col-span-1 mb-4" : "col-span-1"}>
            <span className="text-on-surface-subdued text-xs">
              {t(`admin.treatment.form.${language.toLowerCase()}`)}
            </span>
            <Controller
              control={control}
              name={fieldName}
              render={({ field: { name, value, onChange } }) => (
                <Editor
                  minHeight="100px"
                  autofocus={false}
                  value={value}
                  name={name}
                  maxLength={defaultEditorLength}
                  onChange={onChange}
                />
              )}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export { TreatmentPlanTemplatesSectionInstructionForm }
